import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Scissors, Heart } from 'lucide-react';
const services = [{
  id: 'unas',
  title: 'Uñas',
  subtitle: 'Acrílicas y Esculturales',
  description: 'Técnica de precisión, diseños tendencia y durabilidad garantizada para que tus manos hablen por ti.',
  buttonText: 'Ver Diseños',
  icon: Sparkles,
  image: 'https://cdn.magicpatterns.com/uploads/o1ZfixwGJZwxg7ZR8G2qPX/PHOTO-2026-04-17-19-34-10.jpg'
}, {
  id: 'cabello',
  title: 'Cabello',
  subtitle: 'Color y Corte',
  description: 'Desde tintes clásicos hasta balayage. Cortes que enmarcan tu rostro y devuelven el brillo a tu cabello.',
  buttonText: 'Ver Galería',
  icon: Scissors,
  image: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600'
}, {
  id: 'cuerpo',
  title: 'Cuerpo',
  subtitle: 'Masajes Reductivos',
  description: 'Moldea tu figura y regálale a tu cuerpo el descanso y la firmeza que merece.',
  buttonText: 'Ver Paquetes',
  icon: Heart,
  image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function Services() {
  return <section id="servicios" className="py-24 bg-mimate-bg" data-id="element-101">
      <div className="container mx-auto px-6" data-id="element-102">
        <div className="text-center mb-16" data-id="element-103">
          <h2 className="text-4xl md:text-5xl font-heading text-mimate-text mb-4" data-id="element-104">
            ¿Cómo te quieres consentir hoy?
          </h2>
          <div className="w-24 h-1 bg-mimate-primary mx-auto rounded-full" data-id="element-105"></div>
        </div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-106">
          {services.map(service => {
          const Icon = service.icon;
          return <motion.div key={service.id} variants={itemVariants} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col h-full border border-mimate-primary/10" data-id="element-107">
                <div className="h-64 overflow-hidden relative" data-id="element-108">
                  <div className="absolute inset-0 bg-mimate-text/10 z-10" data-id="element-109"></div>
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" data-id="element-110" />
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm p-3 rounded-full z-20 text-mimate-primary shadow-sm" data-id="element-111">
                    <Icon size={24} data-id="element-112" />
                  </div>
                </div>

                <div className="p-8 flex flex-col flex-grow" data-id="element-113">
                  <h3 className="text-2xl font-heading text-mimate-text mb-1" data-id="element-114">
                    {service.title}
                  </h3>
                  <p className="text-mimate-primary font-semibold mb-4 text-sm uppercase tracking-wider" data-id="element-115">
                    {service.subtitle}
                  </p>
                  <p className="text-mimate-text/70 mb-8 flex-grow leading-relaxed" data-id="element-116">
                    {service.description}
                  </p>

                  <a href="https://wa.me/525554362239?text=Hola%20Valentina%20quiero%20agendar%20una%20cita%20en%20Mimate%20Studio" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 text-mimate-primary hover:text-mimate-primary/70 transition-colors font-semibold" data-id="element-117">
                    <Icon size={20} data-id="element-118" />
                    <span data-id="element-119">{service.buttonText}</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-120">
                      <path d="M5 12h14" data-id="element-121" />
                      <path d="m12 5 7 7-7 7" data-id="element-122" />
                    </svg>
                  </a>
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}